import React from 'react';

const IframeAuth = ({
    src,
    width = '100%',
    height = '100%'
}) => (
    <iframe
        src={src}
        style={{ width, height }}
    />
);

IframeAuth.propTypes = {
    src: React.PropTypes.string.isRequired,
    width: React.PropTypes.string,
    height: React.PropTypes.string
};

export default IframeAuth;



// WEBPACK FOOTER //
// ./app/modal/activation/IframeAuth.js